import { render, staticRenderFns } from "./KusLineGridLabel.vue?vue&type=template&id=3a30c94d"
import script from "./KusLineGridLabel.vue?vue&type=script&lang=js"
export * from "./KusLineGridLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports